













import Vue from "vue";
import { createComponent } from "@vue/composition-api";
import { formValidator } from "@/shared/formValidator";
import { required } from "@/shared/validationRules";
import DefaultRevisionForm from "@/components/DefaultRevisionForm.vue";
import {
  productListResource,
  ProductList,
} from "@megarax/client/src/resources/plm";
import ProductListUnitsTable from "./ProductListUnitsTable.vue";

const validationRules = {
  name: required,
};

export default createComponent({
  components: {
    DefaultRevisionForm,
    ProductListUnitsTable,
  },
  props: {
    value: {
      type: ProductList,
      required: true,
    },
  },
  setup(props, ctx) {
    return {
      ...formValidator(),
      validationRules,
      resource: productListResource,
    };
  },
});
